/**
 * 时间戳转换
 *
 * @param  {number} time   时间戳
 * @param  {string} fmt    格式化字符串
 * @return {string}       格式化后日期
 */
function timeFormat(time, fmt) {
    if (time === void 0) { time = ''; }
    if (fmt === void 0) { fmt = 'yyyy-MM-dd hh:mm'; }
    // 空数据兼容性处理
    !time && (time = new Date());
    // 处理火狐兼容问题
    if (typeof time === 'string') {
        time = time.replace(/-|\./g, '/');
    }
    var date = new Date(time);
    // 非法数据兼容处理
    if (date.toString() === 'Invalid Date') {
        return '';
    }
    var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds(),
    };
    var day = date.getDay().toString();
    var dayData = {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
    };
    if (/(D+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, "\u661F\u671F".concat(dayData[day]));
    }
    if (/([Y|y]+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
    }
    Object.keys(o).forEach(function (k) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1
                ? "".concat(o[k])
                : "00".concat(o[k]).substr("".concat(o[k]).length));
        }
    });
    return fmt;
}

export { timeFormat as t };
//# sourceMappingURL=timeFormat-e4201693.js.map
